<template>
  <footer class="text-secondary small my-5">
    <p class="mb-2">
      Made with
      <a
        class="link-secondary"
        href="https://v3.vuejs.org"
        target="_blank"
        rel="noopener"
        >Vue 3</a
      >
      and
      <a
        class="link-secondary"
        href="https://getbootstrap.com"
        target="_blank"
        rel="noopener"
        >Bootstrap 5</a
      >
    </p>
    <p>
      <a
        class="link-secondary"
        href="https://github.com/davidgaroro/vue-todo-pwa"
        target="_blank"
        rel="noopener"
        >View on GitHub</a
      >
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>
